import { render, staticRenderFns } from "./DriverTachographView.vue?vue&type=template&id=09be1bfa&scoped=true&"
import script from "./DriverTachographView.vue?vue&type=script&lang=js&"
export * from "./DriverTachographView.vue?vue&type=script&lang=js&"
import style0 from "./DriverTachographView.vue?vue&type=style&index=0&id=09be1bfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09be1bfa",
  null
  
)

/* custom blocks */
import block0 from "./DriverTachographView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports